export const SUGGESTIONS_MENU_ATTR = "data-suggestions-menu";
